var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9698 18.5968H5.65011C4.73877 18.5968 4 17.858 4 16.9466V10.9865C4 10.0752 4.73877 9.33643 5.65011 9.33643H14.9699C15.8812 9.33643 16.62 10.0752 16.62 10.9865V16.9466C16.6199 17.858 15.8812 18.5968 14.9698 18.5968Z",
    stroke: "#616161",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1524 9.33645V7.84255C15.1524 5.16808 12.9844 3 10.3099 3C7.63542 3 5.46735 5.16808 5.46735 7.84255V9.33645",
    stroke: "#616161",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3099 13.314V14.6192",
    stroke: "#616161",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.0b78129b49b7a1beac9a17b0697fa019.svg";
export { ForwardRef as ReactComponent };